export default __webpack_public_path__ + "media/radu.e299c46f.jpg";